<template>
  <q-footer
    class="text-white portal-footer"
    :class="bgClass"
  >
    <slot name="before-toolbar" />
    <q-toolbar class="wlk-content-container q-pa-md">
      <div class="pageLinks text-white row q-gutter-x-md">
        <q-btn
          v-for="link in textLinks"
          :key="link.url"
          type="a"
          target="_blank"
          flat
          :href="link.url"
          :label="link.text"
          :ripple="false"
          class="btn-plain footer-link no-focus"
          rel="noopener noreferrer"
          :aria-label="link.urlDescription || `${t('socialLinks.label.textLink')} ${link.text}`"
        />
        <slot name="additional-text-links" />
      </div>
      <q-space />
      <div class="row q-gutter-x-sm items-center social-links q-gutter-x-md">
        <!-- eslint-disable @intlify/vue-i18n/no-missing-keys -->
        <q-item-label v-if="te('followUs')">{{ t('followUs') }}</q-item-label>
        <!-- eslint-enable -->
        <q-btn
          v-for="link in socialLinks"
          :key="link.url"
          type="a"
          target="_blank"
          flat
          :href="link.url"
          :ripple="false"
          class="btn-plain icon no-focus"
          rel="noopener noreferrer"
          :aria-label="link.urlDescription || `${t('socialLinks.label.socialLink')} ${t('socialLinks.'+link.type)}`"
        >
          <q-icon
            :class="link.cls"
            :style="link.css"
            :name="socialIcons[link.icon] || link.icon"
          />
        </q-btn>
      </div>
    </q-toolbar>
  </q-footer>
</template>
<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t, te, getLocaleMessage, setLocaleMessage } = useI18n()

const socialIcons = {
  facebook: 'app:facebook-brands',
  instagram: 'app:instagram-brands',
  youtube: 'app:youtube-brands',
  twitter: 'app:twitter-brands',
  xing: 'app:xing-brands',
  linkedIn: 'app:linkedin-brands',
  mastodon: 'app:mastodon-brands',
  whatsapp: 'app:whatsapp-brands',
  tiktok: 'app:tiktok-brands'
}

const { textLinks, socialLinks, bgColor } = defineProps({
  textLinks: {
    type: Array,
    required: true
  },
  socialLinks: {
    type: Array,
    required: true
  },
  bgColor: {
    type: String,
    default: () => 'primary'
  }
})

const bgClass = computed(() => {
  if (bgColor) {
    return `bg-${bgColor}`
  } else {
    return ''
  }
})

const newMessages = {
  de: {
    socialLinks: {
      facebook: 'Facebook',
      instagram: 'Instagram',
      linkedIn: 'LinkedIn',
      mastodon: 'Mastodon',
      tiktok: 'TikTok',
      twitter: 'Twitter',
      whatsapp: 'WhatsApp',
      xing: 'XING',
      label: {
        textLink: 'Externer Link:',
        socialLink: 'Externer Link zu unserem Profil auf'
      }
    }
  }
}

setLocaleMessage('de-de', { ...newMessages.de, ...getLocaleMessage('de-de') })

</script>
